import { Component, OnInit } from '@angular/core';
import{ FormBuilder,Validators, Form } from '@angular/forms';
import { AppService } from '../app.service';
import { environment } from "src/environments/environment";
import { Router} from "@angular/router";

declare var gtag;
declare var fbq;

@Component({
  selector: 'app-reportproblem',
  templateUrl: './reportproblem.component.html',
  styleUrls: ['./reportproblem.component.css']
})
export class ReportproblemComponent implements OnInit {

  constructor(private service:AppService,private fb:FormBuilder,private router: Router) { }

  ngOnInit() {
    if(environment.production){
    this.service.sendEvents("Completereportproblem", "reportproblem", "ReportProblem");

    fbq('track', "CompleteReportProblem" , {
      content_type: "reportproblem",
      content_title: this.router.url,
    });
  }

    this.service.setTitle('Report a Problem on Propira ');
    this.service.setMetaTags({ property: "og:title", content: 'Report a Problem on Propria' });
    this.service.setMetaTags({ name: "keywords", content: '' });
    this.service.setMetaTags({ name: "description", content: 'Report your problem just by filling out the form and Propria Executive will reach out to you as soon as possible.' });
    this.service.setMetaTags({ property: "og:description", content: 'Report your problem just by filling out the form and Propria Executive will reach out to you as soon as possible.' });

  }

  problem=this.fb.group({
    name:['',Validators.required],
    email:['',[Validators.required,Validators.email]],
    phone:['',[Validators.required,Validators.pattern(/^[6-9]\d{9}$/)]],
    option_value:['',Validators.required], 
    message:['',Validators.required],
  })
 
  get problemControl(){ return this.problem.controls; }
 
  problemSubmit:boolean=false;
  problemLoader:boolean=false;
  problemErrorMsg:string="";
  problemSuccessMsg:string="";
  problemEnd(){
    this.problemErrorMsg="";
    this.problemSuccessMsg="";
    this.problemSubmit=true;
    
    if(this.problem.valid){
      this.problemLoader=true;
      this.service.post('/reportProblemEnd',this.problem.value).subscribe(
        (data:any)=>{
          if(data[0].error=='0'){
             this.problemSuccessMsg=data[0].msg;
             this.problem.reset(); 
             this.problem.patchValue({"option_value":""});
             this.problemSubmit=false;
          }else{ 
            this.problemErrorMsg=data[0].msg;
          }
 
          this.problemLoader=false;
        },(error:any)=>{
          this.problemErrorMsg=error.errorDesc;
          this.problemLoader=false;
        }
      )
    }
  }

  numberOnly(event, length = 0, pointAllow = 0) {
    const iKeyCode = (event.which) ? event.which : event.keyCode;
    if ((pointAllow == 1 && (iKeyCode != 46 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57))) || (pointAllow == 0 && (iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57)))) {
      return false;
    } else if (length > 0) {
      var valueLength = (event.target.value).length;
      if (valueLength >= length) {
        return false;
      }
    } else {
      return true;
    }
  }
  
  validateAlpha(evt){
    var keyCode = (evt.which) ? evt.which : evt.keyCode
    if ((keyCode < 65 || keyCode > 90) && (keyCode < 97 || keyCode > 123) && keyCode != 10  && keyCode != 32 && keyCode != 8 && keyCode != 9)

    return false;
    return true;
  }

}
